export const getCleanErrorMessage = (error: Error): string => {
  // Remove the "Error: " prefix if it exists
  return error.message.replace(/^Error: /, '');
};
